import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X, Heart } from 'lucide-react';
import { siteData } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Why It Matters', href: '#why-it-matters' },
    { label: 'Our Mission', href: '#mission' },
    { label: 'How To Help', href: '#help' },
    { label: 'Petition', href: '#petition' },
    { label: 'Contact', href: '#contact' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-sm py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2 group">
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center transition-colors ${
              isScrolled ? 'bg-emerald-600' : 'bg-white/20 backdrop-blur-sm'
            }`}>
              <span className="text-xl font-bold text-white">JA</span>
            </div>
            <span className={`font-semibold text-lg transition-colors ${
              isScrolled ? 'text-stone-800' : 'text-white'
            }`}>
              {siteData.siteName}
            </span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className={`text-sm font-medium transition-colors hover:opacity-80 ${
                  isScrolled ? 'text-stone-600 hover:text-emerald-600' : 'text-white/90 hover:text-white'
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button
              asChild
              className="bg-amber-500 hover:bg-amber-600 text-stone-900 font-semibold px-6 shadow-lg hover:shadow-xl transition-all"
            >
              <a href={siteData.donateUrl} target="_blank" rel="noopener noreferrer">
                <Heart className="w-4 h-4 mr-2" />
                Donate Now
              </a>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 rounded-lg transition-colors ${
              isScrolled ? 'text-stone-800' : 'text-white'
            }`}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-white/10">
            <nav className="flex flex-col gap-4 pt-4">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`text-sm font-medium ${
                    isScrolled ? 'text-stone-600' : 'text-white/90'
                  }`}
                >
                  {link.label}
                </a>
              ))}
              <Button
                asChild
                className="bg-amber-500 hover:bg-amber-600 text-stone-900 font-semibold mt-2"
              >
                <a href={siteData.donateUrl} target="_blank" rel="noopener noreferrer">
                  <Heart className="w-4 h-4 mr-2" />
                  Donate Now
                </a>
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
